import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import Main from './Main';
import { GoogleOAuthProvider } from '@react-oauth/google';


const clientId = process.env.REACT_APP_GOOGLE_CLIENT_ID;
console.log(clientId)

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <GoogleOAuthProvider clientId={clientId}>
      <Main />
    </GoogleOAuthProvider>
  </React.StrictMode>
);
